/**
 * WebSocket Configuration
 * Centralized configuration for WebSocket connections
 */

// API domain configuration
export const API_DOMAIN = 'security.ncore.kg'
export const API_BASE_URL = `https://${API_DOMAIN}/`

/**
 * Get WebSocket URL for a given path
 * @param {string} path - WebSocket path (e.g., '/ws/chat/room-slug/')
 * @returns {string} Full WebSocket URL
 */
export const getWebSocketUrl = (path) => {
  // Always use secure WebSocket (wss) for production
  const protocol = 'wss:'
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${protocol}//${API_DOMAIN}/${cleanPath}`
}

/**
 * Get HTTP API URL for a given path
 * @param {string} path - API path (e.g., '/community/api/chat-rooms/')
 * @returns {string} Full API URL
 */
export const getApiUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${API_BASE_URL}${cleanPath}`
}

export default {
  API_DOMAIN,
  API_BASE_URL,
  getWebSocketUrl,
  getApiUrl
}
